import { isNumber } from 'lodash';

export const calculateIndexLy = (salesIvLy: number | undefined | null, salesIvLly: number | undefined | null) => {
    if (!isNumber(salesIvLy) || !isNumber(salesIvLly)) return;
    if (salesIvLly <= 0) return 0;

    return Math.round((salesIvLy / salesIvLly) * 100);
};
